/**
 * 客户回款，银行确认单 详情页面配置
 * @author zjs
 * @time 2017-10-26
 */
export default {
    data () {
        return {
            infoConfig : [
                {"label":"流水号","prop":"transaction_no_display"},
                {"label":"开单日期","prop":"work_time"},
                {"label":"商务经办人","prop":"business_name"},
                {"label":"客户名称","prop":"customer_name"},
                {"label":"客户编码","prop":"customer_account"},
                {"label":"联系人","prop":"customer_contact"},
                {"label":"业务团队","prop":"business_team"},
                {"label":"业务员","prop":"saleman_name"},
                {"label":"发票类型","prop":"invoice_type"},
                {"label":"开票单位","prop":"invoice_unit_name"},
                {"label":"上月销售金额","prop":"last_month_sale_amount"},
                {"label":"本月开票金额","prop":"this_month_invoice_amount"},
                {"label":"纳税人识别号","prop":"taxpayer_mark"},
                {"label":"本年销售金额","prop":"this_year_sale_amount"},
                {"label":"本年开票金额","prop":"this_year_invoice_amount"},
                {"label":"地址、电话","prop":"address_phone"},
                {"label":"开户行及账号","prop":"open_bank_account"},
                {"label":"说明","prop":"zhaiyao"}
            ], // 详情信息的配置
            productConfig: {
                head: [
                {
                    "prop":"product_cai",
                    "label":"货品编码",
                    "width": 180
                }, {
                    "prop":"product_name",
                    "label":"货品名称"
                }, {
                    "prop":"specification",
                    "label":"货品规格"
                }, {
                    "prop":"quantity",
                    "label":"数量",
                    "width": 180
                }, {
                    "prop":"price",
                    "label":"单价",
                    "width": 180
                }, {
                    "prop":"amount",
                    "label":"金额",
                    "width": 180
                }, {
                    "prop":"yinyong_no",
                    "label":"引用单据号",
                    "width": 180
                }],
                config: {
                    isNumber:true
                }
            } // 货品的配置
        }
    }
}